import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'

import { updateInputs } from '../../actions/solicitudservicio'


class Cancelacion extends Component {

	render() {

        const { solicitud } = this.props

        const id = solicitud.get('id')

		return (
            <div>

                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label htmlFor="fecha_rechazo" className="control-label" >Fecha de cancelación</label>
                            <input type="date" className="form-control input-sm" name="fecha_rechazo" id="fecha_rechazo" value={moment(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD') || ''} disabled />
                        </div>
                    </div>
                </div>    


                <BoxSection title="Motivo de cancelación">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea type="text" className="form-control input-sm" rows={4} value={ solicitud.get('motivo_cancelacion') || '' } onChange={ (e) => this.props.updateInputs('solicitud.motivo_cancelacion', e.target.value, id) } disabled = { solicitud.get('estado') == 0 } />
                            </div>
                        </div>
                    </div> 

                </BoxSection>
                
                <ModalConfirmarAccion />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        solicitud: state.solicitudservicio.get('solicitud'),
    }
}


function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cancelacion)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/Cancelacion.jsx